import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useRootStore } from 'stores/RootStore'
import { NewValueDialogProps } from 'blaze-ui/ArrayInput/Types'
import { NewValueDrawer } from 'blaze-ui/ArrayInput/NewValueDrawer'
import { NewValueModal } from 'blaze-ui/ArrayInput/NewValueModal'
import { useModals } from 'almanac-ui/Modal'
import { useCallback } from 'react'

export const useAddNewValue = () => {
  const { isMobile } = useResponsiveDesign()
  const { drawersStore } = useRootStore()
  const { openDrawer, closeDrawer } = drawersStore
  const { openModal, closeModal } = useModals()

  return useCallback(
    ({ onSubmit, ...rest }: NewValueDialogProps) => {
      if (isMobile) {
        return openDrawer(NewValueDrawer, {
          onSubmit: (value: string) => {
            onSubmit(value)
            closeDrawer()
          },
          ...rest,
        })
      }
      openModal(NewValueModal, {
        onSubmit: (value: string) => {
          onSubmit(value)
          closeModal()
        },
        ...rest,
      })
    },
    [isMobile, openModal, openDrawer, closeDrawer, closeModal],
  )
}
